import { ClipboardIcon } from "@heroicons/react/20/solid";
import { useCopyToClipboard } from "usehooks-ts";
import { toast } from "react-toastify";

import { useSettings } from "../../../../hooks/useSettings";
import { Paragraph } from "../../../../../common/Atoms/Typography/Paragraph";
import { TwoColFormRow } from "../../../Molecules/Form/TwoColFormRow";

export function ForwardingAddress() {
  const { data: settings } = useSettings();
  const [, copy] = useCopyToClipboard();
  const address = settings?.inboundForwardAddress || ``;

  async function handleCopy() {
    try {
      await copy(address);
      toast.success(`Copied to clipboard`, { autoClose: 200 });
    }
    catch {
      toast.error(`Failed to copy to clipboard`);
    }
  }

  return (
    <TwoColFormRow
      heading={ `Forward emails to Paidnice` }
      description={ `Set up a forwarding rule in your email provider to this address and customer emails will show in your Paidnice inbox, even when they are not replies to a Paidnice email. Emails are matched to contacts by the sender's address.` }
    >
      <div className={ `flex items-center` }>
        <code className={ `rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 break-all` }>
          { address || `-` }
        </code>
        { address ? (
          <ClipboardIcon
            className={ `h-5 w-5 ml-2 shrink-0 text-paidniceGreen-500 cursor-pointer` }
            onClick={ handleCopy }
          />
        ) : null }
      </div>
      <Paragraph className={ `mt-2 text-xs text-gray-500` }>
        { `Gmail and Outlook send a confirmation email when you add a forwarding address. It will appear in your Paidnice email inbox so you can complete the setup from there.` }
      </Paragraph>
    </TwoColFormRow>
  );
}
